import type { ReactNode } from 'react';

import type { IDeliveryRestaurantQuery } from '@fhs-legacy/frontend/src/generated/rbi-graphql';
import type { StoreStatus } from '@fhs-legacy/frontend/src/remote/api/restaurants';
import type { IStore } from '@rbi-ctg/store';

import type {
  DeliveryAddressSelection,
  DeliveryValidationStatus,
} from '../../components/delivery/types';

export interface DeliveryAddressValidation {
  status: DeliveryValidationStatus;
  /** Quotes delivery to the address and, when a restaurant can take it, continues to the menu. */
  validate: (selection: DeliveryAddressSelection) => void;
  /** Returns to `idle`, e.g. once the guest dismisses the no-restaurants modal. */
  reset: () => void;
  /** Dialogs the flow may raise. Render them alongside the panel. */
  dialogs: ReactNode;
}

export type DeliveryRestaurant = IDeliveryRestaurantQuery['deliveryRestaurant'];

export type DeliveryAssignedRestaurant = NonNullable<DeliveryRestaurant['restaurant']>;

export interface InvalidPhoneNumberAlert {
  heading: string;
  body: string;
  buttonLabel: string;
}

export enum DeliveryQuoteOutcomeType {
  SUCCESS = 'success',
  UNAVAILABLE = 'unavailable',
  ERROR = 'error',
  /** No restaurant can take the order right now, for the reason `storeStatus` gives. */
  STORE_STATUS = 'storeStatus',
}

export type DeliveryQuoteOutcome =
  | { type: DeliveryQuoteOutcomeType.SUCCESS; store: IStore }
  | { type: DeliveryQuoteOutcomeType.UNAVAILABLE }
  | { type: DeliveryQuoteOutcomeType.ERROR }
  | { type: DeliveryQuoteOutcomeType.STORE_STATUS; storeStatus: StoreStatus };
